<template lang="pug">
  section.b-stages(v-if="project && currUser")
    StageSortChangePopup(:stages="stages" ref="stageSortChangePopup")
    ._main(ref="main")
      template(v-if="stages.length")
        template(v-for="stage in stages")
          StageTile._block(:key="stage.id" :stage="stage" :project="project" :tasks="tasksOfStage(stage)" ref="stages" :id="stage.id")
      EmptyList._block(v-else vertical) Нет разделов проекта
        Btn(@click="stageModel.addToList(project)" dark xl)
          Icon(name="plus")
          | Новый раздел
      ._footer(v-if="!editingStage && access.canEditStages()")
        Teleport(to=".project-detail-button")
          Btn(@click="stageModel.addToList(project)" dark xl)
            Icon(name="plus")
            | Новый раздел
    BaseTwoWaySticky._aside(:padding="30" :topOffset="35")
      FormBlock(mobile)._nav
        ._aside-header
          ._title Содержание проекта
          BtnResort(:disabled="!stages.length" @click="resortStages")
          BtnExpand(:expanded="!areAllStagesFolded" @toggle="toggleFolding")
        StageListNav(:stages="stages" :selected="selectedStage" @select="selectStage")
</template>

<script>
import Access from '@/utils/access';
import stageModel from '@/model/stage';
import taskListModel from '@/model/taskList';
import modelCustomSettings from '@/model/userCustomSettings';
import Teleport from 'vue2-teleport';

import FormBlock from '@/components/FormBlock.vue';
import UserTile from '@/components/UserTile.vue';
import StageTile from '@/components/StageTile.vue';
import EmptyList from '@/components/ui/EmptyList.vue';
import BtnExpand from '@/components/ui/BtnExpand.vue';
import StageListNav from '@/components/stage/StageListNav.vue';
import BaseTwoWaySticky from '@/components/base/BaseTwoWaySticky.vue';
import BtnResort from '@/components/ui/BtnResort.vue';
import StageSortChangePopup from '@/components/stage/StageSortChangePopup.vue';

export default {
  name: 'ProjectStagesPage',
  components: {
    StageSortChangePopup,
    BtnResort,
    BtnExpand,
    StageListNav,
    EmptyList,
    StageTile,
    UserTile,
    FormBlock,
    Teleport,
    BaseTwoWaySticky,
  },
  data() {
    return {
      selectedStage: null,
    };
  },
  computed: {
    currUser() { return this.$store.state.auth.user; },
    access() { return new Access(this.project, this.currUser); },
    project() { return this.$store.state.project.project; },
    projectMembers() { return this.$store.getters['project/members']; },
    editingStage() { return this.$store.state.stage.editingItem; },
    stages() { return this.$store.getters['stage/itemsHydrated'] ?? []; },
    stageModel() { return stageModel; },
    tasks() { return this.$store.getters['taskList/byStages']; },
    foldedStages() { return this.currUser.customSettings.foldedStages ?? []; },
    stageIds() { return this.stages.map(s => s.id); },
    areAllStagesFolded() { return !this.stageIds.find(id => !this.foldedStages.includes(id)); },
    stageToScroll() {
      const scrollTo = +this.$route.hash.replace('#', '');
      const stagesExist = this.stages?.length;
      const tasksExist = Object.keys(this.tasks).length;
      const exists = stagesExist && tasksExist && scrollTo;

      return exists ? scrollTo : null;
    },
  },
  created() {
    const { projectId } = this.$route.params;
    this.$store.commit('taskList/set', []);

    taskListModel.fetch({ 'stage.project': projectId });
  },
  methods: {
    tasksOfStage(stage) {
      return this.tasks[stage.id] ?? [];
    },
    selectStage(id) {
      const ref = this.$refs.stages.find(r => r.$attrs.id === id);
      const top = ref.$el.getBoundingClientRect().top + window.scrollY - 30;
      window.scrollTo({ top, behavior: 'smooth' });
    },
    toggleFolding(expand) {
      let foldedStages = this.foldedStages.filter(i => this.stageIds.indexOf(i) === -1);

      if (!expand) {
        foldedStages = [...foldedStages, ...this.stageIds];
      }

      modelCustomSettings.set({ foldedStages });
    },
    async resortStages() {
      const res = await this.$refs.stageSortChangePopup.open();

      if (!res) return;

      stageModel.resort(res);
    },
  },
  watch: {
    stageToScroll(val) {
      this.$nextTick(() => {
        const i = this.stages.findIndex(s => s?.id === val);
        if (i !== -1) {
          this.selectStage(i);
        }
      });
    },
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style scoped lang="scss">
.stages {
  padding-top: 35px;
  display: grid;
  grid-template-columns: 5fr 2fr;
  grid-column-gap: 30px;

  &__block {
    margin-bottom: 30px;
  }

  &__title {
    font-size: 18px;
    line-height: 24px;
  }

  &__subtitle {
    font-weight: bold;
    font-size: 11px;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--color-middle-gray);
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }

  &__aside {
    align-self: start;
  }

  &__aside-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
    border-bottom: 1px solid var(--color-super-light);
    padding-bottom: 24px;
    margin-bottom: 24px;

    & > :first-child {
      margin-right: auto;
    }
  }

  &__member {
    padding: 6px 14px;
    background: var(--main-bg);
    margin-bottom: 10px;
  }

  @media (max-width: 1249px) {
    grid-template-columns: 1fr;

    &__aside {
      display: none;
    }
  }
}

</style>
